export const UPDATE_INSIGHTS = 'UPDATE_INSIGHTS'
export const UPDATE_INSIGHT_PAGINATION = 'UPDATE_INSIGHT_PAGINATION'
export const UPDATE_INSIGHT_SEARCH_TERM = 'UPDATE_INSIGHT_SEARCH_TERM'
